import { CoreAPI, createCommonClientConfigMethods } from '@hero/sdk-core';

export function createClientConfigAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonClientConfigMethods(coreAPI),
  };
}
